import { Box, Button, Dialog, DialogContent, Typography, useTheme } from '@mui/material'
import { LoginOutlined } from '@mui/icons-material'
import { observer } from 'mobx-react'

import DownloadStatusListDialog from '../study-material-components/DownloadStatusListDialog'
import { useLayoutContext } from '../../contexts/layout.context'
import Navbar from '../presenter/layout/PresenterNavbar'
import sessionEndedImg from '../../assets/waiting.svg'
import { Outlet, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../store/auth.store'
import React, { useCallback, useEffect } from 'react'
import AuditingSideDrawer from './AuditingSideDrawer'
import aliveLogoImg from '../../assets/alivelogo.png'


const AuditingLayout = observer( ( { navHeadText } ) => {

    const { minSidebarCollapseWidth, setMenuState } = useLayoutContext()

    const navigate = useNavigate()
    const { palette, theme } = useTheme()

    const AuthStore = useAuthStore()

    const handleResizeOrLoad = useCallback( () => {
        if ( window.innerWidth < minSidebarCollapseWidth )
            setMenuState( false )
        else {
            setMenuState( true )
        }
    }, [minSidebarCollapseWidth, setMenuState] )

    useEffect( () => {
        window.addEventListener( 'resize', handleResizeOrLoad )
        window.addEventListener( 'load', handleResizeOrLoad )
        return () => {
            window.removeEventListener( 'resize', handleResizeOrLoad )
            window.removeEventListener( 'load', handleResizeOrLoad )
        }
    }, [handleResizeOrLoad] )

    return (
        <Box flexDirection={{ sm: "row", xs: "column-reverse" }} bgcolor={palette.layoutBackground} display="flex" height="100%" overflow="auto">
            <AuditingSideDrawer />
            <Box
                flexGrow={1}
                display="flex"
                flexDirection="column"
                minWidth="0"
                position="relative"
                overflow="auto"
            >
                <Navbar navHeadText={navHeadText} closeSideMenu={() => setMenuState( false )} openSideMenu={() => setMenuState( true )} />
                {AuthStore.getErpSessionState !== "ended" &&
                    <Box
                        bgcolor={palette.background.default}
                        overflow="auto"
                        borderRadius={{ sm: "10px 0 0 0", xs: "0" }}
                        flexGrow={1}
                        display="flex"
                        id="page-content"
                        className={theme}
                        minWidth="0"
                        position="relative"
                    >
                        <Box position="absolute" sx={{ zIndex: 100, inset: 0, opacity: "0.1", pointerEvents: "none" }} height="100%" display="flex" alignItems="center" justifyContent="center"  >
                            <Box component="img" sx={{ opacity: "0.4" }} width="30%" src={aliveLogoImg} />
                        </Box>
                        <Outlet />
                    </Box>}
            </Box>
            <Dialog open={AuthStore.getErpSessionState === "ended"}>
                <DialogContent >
                    <Box display="flex" alignItems="center" gap="20px" flexDirection="column">
                        <img width="200px" src={sessionEndedImg} alt="Session ended!" />
                        <Typography textAlign="center" variant='subtitle2'>Your ERP session seems to have ended! did you log in using ERP credentials somewhere else? please login again.</Typography>
                        <Button onClick={() => navigate( `/?redirect=${window.location.pathname}` )} startIcon={<LoginOutlined fontSize='small' />} variant='outlined' sx={{ textTransform: "capitalize" }}>Sign In</Button>
                    </Box>
                </DialogContent>
            </Dialog>
            <DownloadStatusListDialog />
        </Box>
    )
} )

export default AuditingLayout
